import Resource from '@/api/resources/Resource'

class LaboratoryHolidaysServices extends Resource {
    async getAllLaboratoryHolidaysByDateRange(params, laboratoryId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/holidays`, { params })
        return response.data
    }
}

export default new LaboratoryHolidaysServices()
